var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cell-content-wrapper l-flex-row l-align-center"},[(_vm.isSharedAudience)?_c('svg-icon',{attrs:{"name":"share","size":"small","title":"shared audience"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }